import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { withMaintenanceCheck } from '@/hocs';
import { makeSelectFormData, makeSelectPhone, makeSelectStep, makeSelectTiming } from '@/model/withdrawal/selectors';
import { WithdrawalStep, WithdrawalUIState } from '@/model/withdrawal/types';
import { withWithdrawalInitialization } from '@/pages/withdrawal/hocs';
import { PreparePage, ReceiverPage, StatusPage, TransferPage } from '@/pages/withdrawal/pages';

const selectFormData = makeSelectFormData();
const selectPhone = makeSelectPhone();
const selectStatus = makeSelectStep();
const selectTiming = makeSelectTiming();

const withRoutesValidation = (Component: React.FunctionComponent, basePath: string) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const { pathname } = useLocation();
  const { step } = useSelector(selectStatus);
  const formData = useSelector(selectFormData);
  const phone = useSelector(selectPhone);
  const timing = useSelector(selectTiming);

  if ((!phone?.value || phone?.value !== formData?.receiver?.phone) && !pathname.endsWith(WithdrawalUIState.RECEIVER)) {
    return <Redirect to={`${basePath}/${WithdrawalUIState.RECEIVER}`} />;
  }
  if (
    // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
    // prettier-ignore
    (step === WithdrawalStep.Running || step === WithdrawalStep.Finished)
    && !pathname.endsWith(WithdrawalUIState.STATUS)
  ) {
    return <Redirect to={`${basePath}/${WithdrawalUIState.STATUS}`} />;
  }
  if (!formData && pathname.endsWith(WithdrawalUIState.STATUS)) {
    return <Redirect to={`${basePath}/${phone ? WithdrawalUIState.RECEIVER : WithdrawalUIState.PREPARE}`} />;
  }
  if (!timing && (pathname.endsWith(WithdrawalUIState.TRANSFER) || pathname.endsWith(WithdrawalUIState.PREPARE))) {
    return <Redirect to={`${basePath}/${WithdrawalUIState.RECEIVER}`} />;
  }
  return <Component {...props} />;
};

const DefaultRoute: React.FC<RouteComponentProps> = ({ location, match: { path } }: RouteComponentProps) => {
  console.warn(`URL not found: ${location.pathname}`);
  return <Redirect to={`${path}/${WithdrawalUIState.RECEIVER}`} />;
};

export const WithdrawalPages: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/${WithdrawalUIState.RECEIVER}`} component={ReceiverPage} />
      <Route path={`${path}/${WithdrawalUIState.PREPARE}`} component={withRoutesValidation(PreparePage, path)} />
      <Route path={`${path}/${WithdrawalUIState.TRANSFER}`} component={withRoutesValidation(TransferPage, path)} />
      <Route path={`${path}/${WithdrawalUIState.STATUS}`} component={withRoutesValidation(StatusPage, path)} />
      <Redirect from="/" to={`${path}/${WithdrawalUIState.RECEIVER}`} />
      <Route component={DefaultRoute} />
    </Switch>
  );
};

export default withMaintenanceCheck('withdrawalDisabled')(withWithdrawalInitialization(true)(WithdrawalPages));
